module.exports = __webpack_public_path__ + "static/smandir-7868c3d61fc7bb549c67249a7eb582b0.jpg";